const pagesSeeder = (server) => {
  server.create('page', 1, 'typeofCompetitionLanding', 'withParentPage');
  server.createList('page', 20);
};

const competitionsSeeder = (server) => {
  server.createList('competition', 20);
};

const eventsSeeder = (server) => {
  server.createList('event', 20);
};

const articlesSeeder = (server) => {
  server.create(
    'article',
    'published',
    'withEvent',
    'withDisciplines',
    'withAthletes',
    'withCompetitions',
    'withArticles',
  );
  server.createList('article', 20);
};

const athletesSeeder = (server) => {
  server.createList('athlete', 100);
};

const disciplinesSeeder = (server) => {
  server.createList('discipline', 20);
};

const documentsSeeder = (server) => {
  server.createList('document', 20);
};

const emailSeeder = (server) => {
  for (let i = 0; i < 20; i += 1) {
    server.create('email', i % 3 === 0 && 'sent');
  }
};

const booksSeeder = (server) => {
  server.createList('book', 20);
};

export default function seeds(server) {
  server.loadFixtures();

  pagesSeeder(server);
  competitionsSeeder(server);
  eventsSeeder(server);
  articlesSeeder(server);
  athletesSeeder(server);
  disciplinesSeeder(server);
  documentsSeeder(server);
  emailSeeder(server);
  booksSeeder(server);
}
